export default __webpack_public_path__ + "static/media/lesnik_winter_a_07.dd18909d.svg";